export const Permission = {
  PATTERN: {
    Create: 'pattern:create',
    Read: 'pattern:read',
    Update: 'pattern:update',
    Delete: 'pattern:delete',
  },
  MATERIAL: {
    Create: 'material:create',
    Read: 'material:read',
    Update: 'material:update',
    Delete: 'material:delete',
  },
  JOINT: {
    Create: 'joint:create',
    Read: 'joint:read',
    Update: 'joint:update',
    Delete: 'joint:delete',
  },
  SEAMLESS_TEXTURE: {
    Create: 'seamless-texture:create',
    Read: 'seamless-texture:read',
    Update: 'seamless-texture:update',
    Delete: 'seamless-texture:delete',
  },
  BRAND: {
    Create: 'brand:create',
    Read: 'brand:read',
    Update: 'brand:update',
    Delete: 'brand:delete',
  },
  USER: {
    Create: 'user:create',
    Read: 'user:read',
    Update: 'user:update',
    Delete: 'user:delete',
  },
  ROLE: {
    Create: 'role:create',
    Read: 'role:read',
    Update: 'role:update',
    Delete: 'role:delete',
  },
  LIMIT: {
    Create: 'limit:create',
    Read: 'limit:read',
    Update: 'limit:update',
    Delete: 'limit:delete',
  },
}